import { MenuRounded } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useGetListDataQuery } from '../../api/apiSlice';
import ExternalScreen from '../../components/fragments/ExternalScreen';
import useAuth from '../../hooks/useAuth';
import { setUser } from '../../store/slices/authSlice';
import FragmentOnlinePastor from './FragmentOnlinePastor';
import GuestLogin from './GuestLogin';
import GuestRegister from './GuestRegister';
import ProfileFragment from './ProfileFragment';

export default function GuestProfileScreen() {
    const [activeScreen, setActiveScreen] = React.useState(0);

    const { isPastor, isLoggedIn } = useAuth();
    const navigate = useNavigate();
    const state = useSelector((st) => st);
    const { user: currentUser } = state.auth;

    const { data: userData, isFetching } = useGetListDataQuery(
        { list: '/user' },
        { refetchOnMountOrArgChange: true }
    );

    userData?.data && setUser(userData?.data);

    return (
        <ExternalScreen
            loading={isFetching}
            title="Profile"
            authPass
            disableSpacing
            disableAppBar={Boolean(!isLoggedIn)}
            disablePadding
            tab
            controls={
                <div>
                    <IconButton
                        color="primary"
                        onClick={() => navigate('/guest-settings')}
                    >
                        <MenuRounded />
                    </IconButton>
                </div>
            }
        >
            {isLoggedIn ? (
                <>
                    <ProfileFragment user={currentUser} />
                    {!!isPastor && <FragmentOnlinePastor user={currentUser} />}
                </>
            ) : (
                <>
                    {activeScreen === 0 ? (
                        <GuestLogin
                            key="login"
                            setActiveScreen={setActiveScreen}
                        />
                    ) : (
                        <GuestRegister
                            key="reg"
                            setActiveScreen={setActiveScreen}
                        />
                    )}
                </>
            )}
        </ExternalScreen>
    );
}
